import React, { Fragment, useState } from 'react';
import List from "@mui/material/List";
import ListItem from "@mui/material/List";
import Collapse from "@mui/material/Collapse";
import './style.css';

const menus = [
    {
        id: 1,
        title: 'Home',
        link: '/',
    },
    {
        id: 2,
        title: 'For Investors',
        link: '/for-investors',
    },
    {
        id: 3,
        title: 'For Pharmacies',
        link: '/for-pharmacies',
    },
    {
        id: 4,
        title: 'Newsroom',
        link: '/newsroom',
    },
    {
        id: 5,
        title: 'About Us',
        link: '/about-us',
    },
    {
        id: 6,
        title: 'Contact Us',
        link: '/contact-us',
    }
]

const MobileMenu = () => {
    const [openId, setOpenId] = useState(0);
    const [menuActive, setMenuState] = useState(false);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <div>
            <div className={`mobileMenu ${menuActive ? "show" : ""}`}>
                <div className="menu-close custom-mobile-menu">
                    <div className="mobile-logo">
                        <a href="/" onClick={ClickHandler} aria-label="Pharmacy Freedom Fund Home">
                            <img
                                src="/Horizontal-Logo-white.png"
                                alt="Pharmacy Freedom Fund"
                                className="mobile-menu-logo"
                            />
                        </a>
                    </div>
                    <div className="clox" onClick={() => setMenuState(!menuActive)}>
                        <i className="ti-close" style={{ fontSize: 15 }}></i>
                    </div>
                </div>

                {/* Logo Section - Removed as per update */}
                {/*<div className="mobile-logo">
                    <NavLink to="/">
                        <img 
                            src="/logo.png" 
                            alt="Pharmacy Freedom Fund" 
                            className="mobile-menu-logo"
                        />
                    </NavLink>
                </div>*/}

                <ul className="responsivemenu">
                    {menus.map((item, mn) => {
                        return (
                            <ListItem className={item.id === openId ? 'active' : null} key={mn}>
                                {item.submenu ?
                                    <Fragment>
                                        <p onClick={() => setOpenId(item.id === openId ? 0 : item.id)}>
                                            {item.title}
                                            <i className={item.id === openId ? 'fa fa-angle-up' : 'fa fa-angle-down'}></i>
                                        </p>
                                        <Collapse in={item.id === openId} timeout="auto" unmountOnExit>
                                            <List className="subMenu">
                                                <Fragment>
                                                    {item.submenu.map((submenu, i) => {
                                                        return (
                                                            <ListItem key={i}>
                                                                <a
                                                                    onClick={ClickHandler}
                                                                    className="active"
                                                                    href={submenu.link}
                                                                >
                                                                    {submenu.title}
                                                                </a>
                                                            </ListItem>
                                                        )
                                                    })}
                                                </Fragment>
                                            </List>
                                        </Collapse>
                                    </Fragment>
                                    : <a
                                        className="active"
                                        href={item.link}
                                        onClick={ClickHandler}
                                    >
                                        {item.title}
                                    </a>
                                }
                            </ListItem>
                        )
                    })}
                </ul>
            </div>

            <div className="showmenu mobail-menu" onClick={() => setMenuState(!menuActive)}>
                <button type="button" className="navbar-toggler open-btn">
                    <span className="icon-bar first-angle"></span>
                    <span className="icon-bar middle-angle"></span>
                    <span className="icon-bar last-angle"></span>
                </button>
            </div>
        </div>
    )
}

export default MobileMenu;

